
import React from 'react';
import { AnimatedSection } from '../../../components/base/AnimatedSection';

export const AdditionalServicesSection = () => {
  const handleServiceWhatsApp = (serviceName: string) => {
    const message = `Olá vim do site e gostaria de mais informações sobre ${serviceName}`;
    window.open(`https://wa.me/554888397243?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleWhatsApp = (service: string) => {
    const message = `Olá! Gostaria de saber mais sobre: ${service}`;
    window.open(`https://wa.me/554888397243?text=${encodeURIComponent(message)}`, '_blank');
  };

  const handleWhatsAppPackage = () => {
    const message = 'Olá! Gostaria de criar um pacote personalizado de serviços complementares.';
    window.open(`https://wa.me/554888397243?text=${encodeURIComponent(message)}`, '_blank');
  };

  const additionalServices = [
    {
      category: 'Reparos e Personalização',
      services: [
        {
          name: 'Martelinho de Ouro',
          description: 'Remoção de pequenos amassados sem danificar a pintura original',
          icon: 'ri-hammer-line'
        },
        {
          name: 'Pintura e Personalização',
          description: 'Serviços de pintura e customização para deixar seu carro único',
          icon: 'ri-brush-2-line'
        },
        {
          name: 'Envelopamento',
          description: 'Mudança de cor e proteção com películas de alta qualidade',
          icon: 'ri-palette-line'
        }
      ]
    },
    {
      category: 'Limpeza Especializada',
      services: [
        {
          name: 'Lavação de Motor',
          description: 'Limpeza profunda e segura do compartimento do motor',
          icon: 'ri-settings-3-line'
        },
        {
          name: 'Oxi-sanitização',
          description: 'Eliminação de vírus, bactérias e odores com ozônio',
          icon: 'ri-shield-check-line'
        },
        {
          name: 'Lavação de Chassis',
          description: 'Limpeza completa da parte inferior do veículo',
          icon: 'ri-car-washing-line'
        }
      ]
    },
    {
      category: 'Proteção e Acabamento',
      services: [
        {
          name: 'Hidratação dos Couros',
          description: 'Tratamento e proteção para bancos e revestimentos de couro',
          icon: 'ri-drop-line'
        },
        {
          name: 'Vitrificação dos Bancos',
          description: 'Proteção cerâmica para tecidos e estofados',
          icon: 'ri-shield-star-line'
        },
        {
          name: 'Cristalização de Para-brisas',
          description: 'Proteção e repelência de água para máxima visibilidade',
          icon: 'ri-eye-line'
        }
      ]
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-[#0D0D0D] to-[#1A1A1A]">
      <div className="container mx-auto px-6">
        <AnimatedSection animation="fadeIn" className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 tracking-wide px-4">
            SERVIÇOS COMPLEMENTARES
          </h2>
          <p className="text-gray-300 text-base md:text-lg max-w-2xl mx-auto px-4">
            Serviços adicionais para manter seu veículo sempre impecável
          </p>
        </AnimatedSection>

        <div className="space-y-12">
          {additionalServices.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-[#1C1C1C] rounded-lg border border-[#C8A45D]/20 p-8">
              <h3 className="text-2xl font-bold text-[#C8A45D] mb-8 text-center">
                {category.category}
              </h3>
              
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {category.services.map((service, serviceIndex) => (
                  <div 
                    key={serviceIndex}
                    className="bg-[#0D0D0D] rounded-lg p-6 border border-[#C8A45D]/10 hover:border-[#C8A45D]/30 transition-all duration-300 hover:transform hover:-translate-y-1"
                  >
                    <div className="flex items-start space-x-4">
                      <div className="w-12 h-12 bg-[#C8A45D] rounded-full flex items-center justify-center flex-shrink-0">
                        <i className={`${service.icon} text-black text-xl`}></i>
                      </div>
                      <div className="flex-1">
                        <h4 className="text-lg font-bold text-white mb-2">{service.name}</h4>
                        <p className="text-gray-400 text-sm mb-4 leading-relaxed">{service.description}</p>
                        <button
                          onClick={() => handleServiceWhatsApp(service.name)}
                          className="text-[#C8A45D] hover:text-white text-sm font-medium transition-colors duration-300 flex items-center whitespace-nowrap cursor-pointer"
                        >
                          <i className="ri-whatsapp-line mr-2"></i>
                          Solicitar Orçamento
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* CTA Section */}
        <div className="mt-16 text-center">
          <div className="bg-[#C8A45D] p-8 rounded-lg max-w-4xl mx-auto">
            <h3 className="text-2xl font-bold text-black mb-4">Precisa de uma combinação de serviços?</h3>
            <p className="text-black/80 mb-6">
              Criamos pacotes personalizados combinando nossos serviços principais e complementares para oferecer o melhor custo-benefício.
            </p>
            <div className="flex justify-center">
              <button
                onClick={() => handleServiceWhatsApp('pacote personalizado de serviços')}
                className="bg-[#0D0D0D] text-white font-bold py-3 px-6 rounded-lg hover:bg-[#1A1A1A] transition-all duration-300 transform hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer text-sm md:text-base"
              >
                <i className="ri-chat-3-line mr-2"></i>
                MONTAR PACOTE PERSONALIZADO
              </button>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};
